import AsyncLoader from './src/AsyncLoader'
import Data from './src/data/Data'
import Loader from './src/views/Loader'
import BestVenues from './src/views/BestVenues'
import {
	searchToObject,
	langToObject
} from './src/utils/index'

import Category from './src/filters/Category'
import EventType from './src/filters/EventType'
import NumberOfGuest from './src/filters/NumberOfGuest'

const ADDITION_OF_EACH_BESTVENUES = 12

class AsyncFilter extends AsyncLoader {
	constructor({
		container,
		filtersContainer
	}, lang) {
		super(container)
		this.data = []
		this.filtersContainer = filtersContainer
		this.lang = langToObject(lang)
	}

	async init(filters) {
		this.loader = new Loader(this.container)
		this.bestVenues = new BestVenues(this.container)
		this.addFilters()
		this.addObserversToFilters()
		this.addDataController(filters)
		this.checkRoute()
		await this.loadData()
		this.addListener()
		const resetvenues = document.getElementById('resetvenues')
		resetvenues.addEventListener('click', () => this.clearFilters())
	}

	checkRoute() {
		const search = searchToObject(window.location.search)
		if (search) {
			if (search.category) {
				this.category.setFilter(search.category)
			}
			if (search.etype) {
				this.eventType.setFilter(search.etype)
			}
		}
		document.querySelector('#catbutton').textContent = 'None Selected'
		document.querySelector('#eventypebutton').textContent = 'None Selected'
    }

	clearFilters () {
		this.category.setFilter('', true)
		this.eventType.setFilter('', true)
		this.numberOfGuest.resetFilter()
		this.loadData(true)
	}

	addFilters() {
		this.category = new Category(this.filtersContainer, this.container)
		this.eventType = new EventType(this.filtersContainer, this.container)
		this.numberOfGuest = new NumberOfGuest(this.filtersContainer, this.container)
	}

	addObserversToFilters() {
		this.category.addObserver(this.loadData.bind(this))
		this.eventType.addObserver(this.loadData.bind(this))
		this.numberOfGuest.addObserver(this.loadData.bind(this))
	}

	addDataController(filters) {
		this.dataController = new Data(filters)
		this.dataController.addObserver(this.downloadAll.bind(this))
	}

	async loadData(resetParametrs = false) {
		if (resetParametrs) {
			this.clearData()
			this.blockFilters()
		}
		if (this.isLoadedAll) return
		this.loader.turnOn()
		this.data = await this._getData()
		this.bestVenues.setBestVenues(this.data.slice())
		this.loader.turnOff()
		if (resetParametrs) this.unblockFilters()
	}

	clearData () {
		this.data = []
		this.dataController.clear()
		this.bestVenues.clear()
		this.isLoadedAll = false
	}

	blockFilters() {
		this.filtersContainer.classList.add('venues-detail__filters--block')
		this.category.blockFilters()
		this.eventType.blockFilters()
		this.numberOfGuest.blockFilters()
	}

	unblockFilters() {
		this.filtersContainer.classList.remove('venues-detail__filters--block')
		this.category.unblockFilters()
		this.eventType.unblockFilters()
		this.numberOfGuest.unblockFilters()
	}

	async _getData() {
		const fetchFrom = this.data.length
		const fetchTo = fetchFrom + ADDITION_OF_EACH_BESTVENUES
		const categoryFilters = this.category.get()
		const eventTypeFilters = this.eventType.get()
		const numberOfGuest = this.numberOfGuest.get()
		this.setTitle(categoryFilters, eventTypeFilters)
		this.setRoute(categoryFilters, eventTypeFilters)
		await this.dataController.fetch(
			fetchFrom,
			fetchTo,
			numberOfGuest,
			categoryFilters,
			eventTypeFilters
		)
		return this.dataController.get()
	}

	setTitle(category, type) {
		const defaultTitle = 'Best Event Venues in New York'
		const title = document.querySelector('#venues-detail-title')
		const catbox = document.querySelector('#catbutton')
		const typebox = document.querySelector('#eventypebutton')

		if (!category.length && !type.length) {
			title.textContent = defaultTitle
			catbox.textContent = 'None Selected'
			typebox.textContent = 'None Selected'

		} else {
			if (category.length) {
				const categoryTitle = category.map(cat => this.lang.category[cat]).join(', ')
				title.textContent = categoryTitle
				let catlenght = category.length - 1
				let catText = category[0] + ' +' + catlenght
				if (category.length > 1) {
					catbox.innerHTML = catText
				} else {
					catbox.textContent = category[0]
				}
				if (type.length === 0) {
					typebox.textContent = 'None Selected'
				}
				if (type.length) {
					const typeTitle = type.map(typ => this.lang.type[typ]).join(', ')
					title.textContent += ' / ' + typeTitle
					let typelength = type.length - 1
					let typeText = type[0] + ' +' + typelength
					if (type.length > 1) {
						typebox.innerHTML = typeText
					} else {
						typebox.textContent = type[0]
					}
				}
				title.textContent += ' in New York'
			} else {
				const typeTitle = type.map(typ => this.lang.type[typ]).join(', ')
				title.textContent = typeTitle + ' in New York'
				catbox.textContent = 'None Selected'

				let typelength = type.length - 1
				let typeText = type[0] + ' +' + typelength
				if (type.length > 1) {
					typebox.innerHTML = typeText
				} else {
					typebox.textContent = type[0]
				}
			}
		}
	}

	setRoute(category, type) {
		const typ = type.length ? 'etype=' + type.join(',') : ''
		let cat = category.length ? 'category=' + category.join(',') : ''
		console.log(cat)
		if (cat && typ) cat += '&'
		const loc = window.location
		const siteURL = loc.protocol + '//' + loc.host + loc.pathname
		const newURL = (!cat && !typ) ? siteURL : siteURL + '?' + cat + typ
		window.history.pushState({
			path: newURL
		}, '', newURL)
	}
}

window.AsyncFilter = AsyncFilter



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/async_filters/script.js